// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__14bdP","image":"Header_image__17-Ps","name":"Header_name__1Q7de","info":"Header_info__2EYOR","infoRow":"Header_infoRow__2SMoR"};